/**
 * Employee Incident Bulk Approval Service
 * HTTP operations for the bulk approval of pending marking incidents
 * (ASIS-5249 / REXASIS-007)
 */
import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type { LC_BulkApproveIncidentsIn, LC_BulkApproveIncidentsOut } from '../types';

/**
 * Service for approving multiple marking incidents in a single operation.
 */
export class EmployeeIncidentBulkApproveService {
  /**
   * Approve multiple marking incidents in one call (ASIS-5249). Sends the incident IDs
   * as CSV plus the mandatory approver comment; the approver identity is resolved on
   * the backend (JWT). Always returns HTTP 200 with a per-incident outcome
   * discriminator ('approved' | 'alreadyResolved') and aggregated totals.
   * PUT /v1/attendances/incidents/bulk-approval
   */
  bulkApprove(
    input: LC_BulkApproveIncidentsIn,
  ): Promise<ApiResponse<LC_BulkApproveIncidentsOut>> {
    return apiClient.put<LC_BulkApproveIncidentsOut>(
      API_CONFIG.ENDPOINTS.EMPLOYEE_INCIDENTS.BULK_APPROVE_MANAGEMENT(),
      input,
    );
  }
}

export const employeeIncidentBulkApproveService = new EmployeeIncidentBulkApproveService();
